module.exports = __webpack_public_path__ + "_/_/src/components/catalog-bar/wall.png";